const defaultOnNaN = (value, defaultValue) => (!Number.isNaN(value) ? value : defaultValue);

const withUnit = (value, unit) => {
  if (unit === 'percent') {
    return `${value}%`;
  }
  if (unit === 'pages') {
    return `page ${value}`;
  }

  throw new Error(`Unknown unit! [${value}])`);
};

export {
  defaultOnNaN,
  withUnit,
};
